module.exports = __webpack_public_path__ + "static/img/map_shandong.5e96aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_shandong.png
// module id = Uc2k
// module chunks = 0